import { JustpayPointEndpoint } from "@/views/loyalty/shared/endpoint_services/justpay-point-endpoint-service"

export class JustpayPointService {
    constructor () {
        this.justpayPointEndpoint = new JustpayPointEndpoint()
    }

    async checkOwnedEquipment (equipmentId) {
        return this.justpayPointEndpoint.checkOwnedEquipment(equipmentId)
    }

    async getAllPoints () {
        const points = await this.justpayPointEndpoint.getAllPoints()
        return points || []
    }

    async getPoint (jsonArg) {
        return this.justpayPointEndpoint.getPoint(jsonArg)
    }

    // get point by any json argument
    async getPoints (jsonArg) {
        return this.justpayPointEndpoint.getPoints(jsonArg)
    }

    async getPointMonitoring () {
        const points = await this.justpayPointEndpoint.getPointMonitoring()
        return points || []
    }

    async getPlacePoints (clientId) {
        const points = await this.justpayPointEndpoint.getAllPointsbyClientId(clientId)
        console.log('getPlacePoints points=', points)
        const placePoints = points.data.map(m => {
            const place = points.places.find(f => f.id === m.place)
            // console.log('getPlacePoints place', place)
            m.place_item = place
            return m
        }).filter(f => f.state !== 2)
        // console.log('placePoints', placePoints)
        return placePoints
    }

    async getPointsForFiltering () {
        const points = await this.justpayPointEndpoint.getPointsForFiltering()
        return points.data.map(point => {
            return { value: point.value, text: point.text }
        })
    }

    async getPointsForPaymentFilter (clientId) {
        let points = {}
        if (clientId !== undefined) {
            points = await this.justpayPointEndpoint.getAllPointsbyClientId(clientId)
        } else {
            points = await this.justpayPointEndpoint.getAllPoints()
        }
        let points_for_filter
        if (points) {
            points_for_filter = points.data.map(point => {
                return { value: point.name, text: point.name }
            })
        } else {
            points_for_filter = [{ value: '', text: '' }]
        }
        return points_for_filter
    }

    // for Final Recon , value: point.id, text: point.name
    async getPointsForPaymentFilter2 (clientId) {
        let points = {}
        if (clientId !== undefined) {
            points = await this.justpayPointEndpoint.getAllPointsbyClientId(clientId)
        } else {
            points = await this.justpayPointEndpoint.getAllPoints()
        }
        let points_for_filter
        if (points) {
            points_for_filter = points.data.map(point => {
                return { value: point.id, text: point.name }
            })
        } else {
            points_for_filter = [{ value: '', text: '' }]
        }
        return points_for_filter
    }
}
